// faq
$(document).ready(function() {
    $('.questions').click(function() {
      var $faqData = $(this).find('.faq-data');
     
  
      var $faqPlus = $(this).find('.faq-plus');
      var $faqMinus = $(this).find('.faqminus');

      // Check if .faq-data has class 'hidden' to determine visibility
      var isDataHidden = $faqData.hasClass('hidden');
      console.log(isDataHidden)
       $faqData.slideToggle();
      if (!isDataHidden) {
        $faqPlus.removeClass('hidden');
        $faqMinus.addClass('hidden');
        $faqData.addClass('hidden');
      } else {
        $faqPlus.addClass('hidden');
        $faqMinus.removeClass('hidden');
        $faqData.removeClass('hidden');
      }
    });
  });